import { TruckTypeState, Reducer, ReducerActions, truckTypeStateActions, TruckTypeStateAction } from '@/context/types';

const makeTruckStateInitialState = (): TruckTypeState => ({ data: [], isLoading: false });

const reducerActions: ReducerActions<TruckTypeState, TruckTypeStateAction> = (state, payload) => ({
  truck_type_load_start: () => ({ ...state, data: [], isLoading: true }),
  truck_type_load_end: () => ({ ...state, isLoading: false }),
  truck_type_update_data: () => ({ ...state, data: [...payload], isLoading: false }),
});

export const truckTypeReducer: Reducer<TruckTypeState, TruckTypeStateAction> = (state, { action, payload }) =>
  truckTypeStateActions.includes(action) ? reducerActions(state, payload)[action]() : { ...state };

truckTypeReducer.key = 'truckTypes';
truckTypeReducer.initialState = makeTruckStateInitialState();
